import { reduxActions } from '../constants';

const defaultOptions = {
    message: '',
    type: 'NORMAL',
    action: () => {},
    lifeSpan: 5000
}

export default class GrowlActions {
    static addGrowl(id, growl) {
        return {
            type: reduxActions.ADD_GROWL,
            growl: growl,
            growlId: id
        }
    }

    static removeGrowl(growlId) {
        return {
            type: reduxActions.REMOVE_GROWL,
            growlId: growlId
        }
    }

    static delayGrowl(growlId) {
        return {
            type: reduxActions.DELAY_GROWL,
            growlId: growlId
        }
    }

    static notify(message, options) {
        let growl = Object.assign({}, defaultOptions, options, {
            message
        });

        return (dispatch, getState) => {
            const { nextGrowlId } = getState();
            const timeoutId = setTimeout(() => {
                dispatch(GrowlActions.removeGrowl(nextGrowlId));
            }, growl.lifeSpan);
            growl.timeout = timeoutId;

            dispatch(GrowlActions.addGrowl(nextGrowlId, growl));

        }
    }
}



// WEBPACK FOOTER //
// ./web-app/actions/growl-actions.js